export const useServiceType = () => {
  const config = useRuntimeConfig()
  const serviceType = config.public.serviceType
  const isJps = config.public.isJps
  const isHina = config.public.isHina
  return {
    isJps,
    isHina,
    serviceType,
  }
}

// 使い方
// const { isJps, isHina, serviceType } = useServiceType()